import { useLocalStorage } from "./storage";

export function useAccessTokens() {
  return useLocalStorage("accessTokens", {});
}
